import {
    MaterialReactTable,
    useMaterialReactTable,
  } from 'material-react-table';
  import { darken, lighten, useTheme, Button } from '@mui/material';
  import { useTranslation } from 'react-i18next';
  import { useEffect, useState } from 'react';
  import { isArray } from 'util';
  export default function DatatTable(props) {
    const { columnData, rowsData } = props.tableData;
    const { i18n, t } = useTranslation();
    const [rowSelection, setRowSelection] = useState([]);
    const [isAllRowSelected, setIsAllRowSelected] = useState(false);
    // const captureRowSelectHandler = (event) => {
    //   for (let [k, v] of Object.entries(event())) {
    //     if (v) {
    //       setRowSelection((prev) => [...prev, k]);
    //       const rowSelection =; //read state
    //       const selectedRows = table.getSelectedRowModel().rows; //or read entire rows
    //       props.onClickSelect(selectedRows);
    //     }
    //   }
    // }
    const selectClickHandler = (row, staticRowIndex, table, event) => {
      // const selectedRows = table.getSelectedRowModel().rows; //or read entire rows
      // props.onClickSelect(row);
      // console.log(event);
      // console.log(table.getSelectedRowModel().rows);
      // getMRT_RowSelectionHandler({row, staticRowIndex, table})(event);
      // row.getToggleSelectedHandler();
      // console.log("row id",row.id);
  
      // console.log("radio check",row.toggleSelected());
      if(!row.getIsSelected()) row.toggleSelected();
      // row.toggleSelected();
      // dummy();
  
    }
    // const dummy = ()=>{
    //   console.log("1=>",table.getSelectedRowModel().rows);
    //   console.log("2=>",rowSelection);
    //   if(props.onClickSelect) props.onClickSelect(table.getSelectedRowModel().rows);
    // }
  
    let tableConfig = {
      columns: columnData,
      data: rowsData,
      enableFullScreenToggle: false,
      enableMultiRowSelection: false,
      enableDensityToggle: false,
      enableColumnFilters:false,
      enableHiding:false,
      enableTopToolbar: false,
      enableBottomToolbar: props.enablePagination?true:false,
      enableColumnActions:true,
      enableSorting : false,
      enableRowSelection: props.enableSelection,
      positionToolbarAlertBanner: 'none',
      enablePagination: props.enablePagination,
      onRowSelectionChange: setRowSelection, //connect internal row selection state to your own
      state: { rowSelection }, //pass our managed row selection state to the table to use
      getRowId: (row) => row.asigneeGroupId,
      initialState: { density: 'compact' },
      defaultColumn: {
        // maxSize: 200,
        minSize: 80,
        size: 160,
      },
      muiTablePaperProps: {
        elevation: 0,
        sx: {
          borderRadius: '2px',
          border: '1px dashed #e0e0e0',
          textAlign: "center",
  
        },
      },
      muiTableHeadCellProps: {
        sx: {
          fontWeight: 'normal',
          fontSize: '14px',
          whiteSpace: 'nowrap',
        },
      },
      muiTableBodyRowProps: ({ row, staticRowIndex, table }) => ({
        onClick: () => {debugger;selectClickHandler(row, staticRowIndex, table)},
        sx: {
          color: '#333',
          fontFamily: 'roboto',
          fontSize: '0.96775rem',
          fontStyle: 'normal',
          fontWeight: '400',
          lineHeight: 'normal',
          letterSpacing: '0.04838rem',
          //if row.original.email is email id then leave it as it is
          textTransform: row.original.email ? 'none' : 'capitalize',
  
        },
      }),
      enableColumnResizing: true,
      layoutMode: 'grid',
      muiPaginationProps: {
        showRowsPerPage: false,
        rowsPerPageOptions: props.rowCount ? props.rowCount : [10, 25, 50, 100],
        showFirstButton: false,
        showLastButton: false,
        shape: 'rounded',
        color: 'primary',
        variant: 'outlined',
      },
      paginationDisplayMode: 'pages',
      enableGlobalFilter: false,
      // enableRowNumbers: props.enableSelection?false:true,
      enableRowNumbers: false,
      
      localization: { rowsPerPage: t('feedback.viewFeedback.rowsPerPage') }
  
    }
  
    // if (props.enableSelection) {
    //   tableConfig.renderTopToolbarCustomActions = ({ table }) => (
    //     <Button
    //       variant="text"
    //       color="primary"
    //       hidden={rowSelection.length === 0}
    //       onClick={() => {
  
    //       }}
    //     >
    //       Confirm Selection
    //     </Button>
    //   )
    // }
    const table = useMaterialReactTable(tableConfig);
  
    const headerCells = document.querySelectorAll('.MuiTableHead-root th');
    headerCells.forEach((cell) => {
      cell.style.backgroundColor = '#867FA1';
      cell.style.color = 'white';
    });
    if (!isAllRowSelected && rowsData.length === 1) {
      const { toggleAllRowsSelected, getToggleAllRowsSelectedHandler } = table;
      // console.log("toggleAllRowsSelected",getToggleAllRowsSelectedHandler());
      toggleAllRowsSelected(true);
      setIsAllRowSelected(true);
    }
    useEffect(() => {
      // console.log("rowSelection", rowSelection);
      // console.log("table.getSelectedRowModel().rows", table.getSelectedRowModel().rows);
      if (props.onClickSelect &&
        (
          (Array.isArray(rowSelection) && rowSelection.length > 0)
          ||
          (typeof rowSelection === 'object' && rowSelection !== null && Object.keys(rowSelection).length > 0)
        )
      ) {
        props.onClickSelect(table.getSelectedRowModel().rows);
      }
      // console.log("Rows Data", rowsData.length);
  
  
    }, [rowSelection]);
  
  
    return <MaterialReactTable table={table} />;
  };
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  